import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Card, Container } from 'reactstrap';
import classNames from 'classnames';
import { Image } from '@bottomless/common/components';
import { QuizHeader } from './QuizHeader';
import { QuestionText } from './QuestionText';

const answers = [
  {
    name: "I'm almost out",
    value: 'dateOverride:0',
    event: { dateOverride: '0' },
  },
  {
    name: '1 week',
    value: 'dateOverride:nextBusiness',
    event: { dateOverride: 'nextBusiness' },
  },
  {
    name: '2 weeks',
    value: 'dateOverride:1',
    event: { dateOverride: '1' },
  },
  {
    name: '3+ Weeks',
    value: 'dateOverride:2',
    event: { dateOverride: '2' },
  },
];

export const Question6 = ({ index, total, displayIndex, displayTotal, onAnswer, answers: quizAnswers, isMobile }) => {
  return (
    <>
      <QuizHeader
        index={displayIndex}
        total={displayTotal}
        quizAnswers={quizAnswers}
        description="Just one click from happiness."
      />
      <QuestionText
        index={index - 1}
        total={total - 1}
        title="Current stock"
        subtitle="How much coffee do you have on hand?"
      />
      <div className="answers">
        <Container className="mt-4 px-0">
          <Row className="justify-content-center quiz-answer-row">
            {answers.map(answer => (
              <Col key={answer.value} xs="12" sm="6" lg="3" className="quiz-answer-col">
                <Card
                  body
                  tag="button"
                  className={classNames(
                    'd-flex flex-md-row flex-column align-items-center justify-content-center w-100 answer',
                    {
                      'answer-selected': quizAnswers?.[index] === answer.value,
                    }
                  )}
                  onClick={() => onAnswer(answer)}
                >
                  {quizAnswers?.[index] === answer.value && <span className="quiz-answer-check">✓</span>}
                  <Image src="/assets/q6-img.png" width="30" alt={`Answer - ${answer.name}`} />
                  <p
                    className={classNames('mb-0', {
                      'ml-4': !isMobile,
                      'mt-2': isMobile,
                    })}
                  >
                    {answer.name}
                  </p>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </>
  );
};

Question6.propTypes = {
  index: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  displayIndex: PropTypes.number.isRequired,
  displayTotal: PropTypes.number.isRequired,
  onAnswer: PropTypes.func.isRequired,
  answers: PropTypes.object,
  isMobile: PropTypes.bool.isRequired,
};

Question6.scheduleRelated = true;
